module.exports = __webpack_public_path__ + "img/56.72939fc9.jpg";